
import axios from './rest-axios';

const getMessages = () => axios.get(`/manage/messages`);
const getMessageCount = () => axios.get(`/manage/messages/count`);
const putMessageRead = (id) => axios.put(`/manage/messages/${id}/read`);
const postMessageReadAll = () => axios.post(`/manage/messages/readall`);

export {
    getMessages,
    getMessageCount,
    putMessageRead,
    postMessageReadAll,
};
